import * as React from 'react';
import { cx } from '@/lib/utils/cn';

/**
 * The two panes of an area view (the Findings area page, 5 Nov 2026): a
 * list on the left and the detail of the selected row on the right, each
 * scrolling by itself, so the line above them that says where the area
 * stands never scrolls away. Below the large breakpoint the panes stack
 * and the whole view scrolls as one column.
 */
export function AreaPanes({
  label,
  list,
  detail,
  className,
}: {
  /** The region's name, for example "Process today". */
  label: string;
  list: React.ReactNode;
  /** Null: the list takes the whole width (a reading view). */
  detail: React.ReactNode | null;
  className?: string;
}) {
  return (
    <section
      aria-label={label}
      className={cx(
        'min-h-0 flex-1 overflow-y-auto',
        detail !== null &&
          'lg:grid lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:overflow-hidden',
        className,
      )}
    >
      <div className={cx('min-w-0', detail !== null && 'lg:overflow-y-auto')}>{list}</div>
      {detail !== null ? (
        <div className="min-w-0 border-t border-ink-100 bg-paper-0 px-5 py-4 lg:overflow-y-auto lg:border-l lg:border-t-0">
          {detail}
        </div>
      ) : null}
    </section>
  );
}

/** The small uppercase label over a block of the detail pane. */
export function DetailLabel({ children }: { children: React.ReactNode }) {
  return (
    <p className="mb-1.5 mt-4 text-[11px] font-semibold uppercase leading-[18px] tracking-[0.06em] text-ink-500">
      {children}
    </p>
  );
}
